module.exports = __webpack_public_path__ + "img/trial3-4.13de1613.png";